import React, { useEffect } from 'react';
import { Translation } from 'react-i18next';
import { Button, Card, Col, Row, Space, Spin } from 'antd';
import { LoadingOutlined, PlusCircleOutlined } from '@ant-design/icons';
import CognitoFormsList from '../containers/CognitoFormsListContainer';
import CognitoFormsCSVButton from '../containers/CognitoFormsCSVButtonContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import { pathTo } from '../../../Routes';
import Config from '../../../../../Config';
import QueryString from '../../../../../lib/QueryString';
import Logger from '../../../../../lib/Logger';

const CognitoFormsScreen = ({ isDownloading, total, download, ...props }) => {
  const limit = Config.get('DEFAULT_LIST_LENGTH', 10);

  const scrollToTop = () => {
    Logger.log('debug', `CognitoFormsScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  };

  const loadingIcon = (
    <Spin indicator={<LoadingOutlined style={{ fontSize: 20 }} spin />} />
  );

  const page = parseInt(props.match.params.page ? props.match.params.page : 1);
  const { order, ...filter } = QueryString.parse(props.location.search);

  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <Translation>
      {(t) => (
        <div>
          <DocumentHead title={t('cognito_forms_route_list')} />

          <Row>
            <Col span={24}>
              <Card
                title={
                  <Space size={10}>
                    {t('cognito_forms_list_title')}
                    <Button
                      size='small'
                      icon={<PlusCircleOutlined />}
                      onClick={(e) =>
                        props.history.push(pathTo('CognitoFormAddScreen'))
                      }
                    >
                      {t('action_create')}
                    </Button>

                    <CognitoFormsCSVButton order={order} filter={filter} />
                  </Space>
                }
                extra={props.isLoading ? loadingIcon : null}
              >
                <CognitoFormsList
                  key={page}
                  component='CognitoFormsScreen'
                  page={page}
                  limit={limit}
                  order={order || 'updated_at.desc'}
                  filter={filter}
                />
              </Card>
            </Col>
          </Row>
        </div>
      )}
    </Translation>
  );
};

export default CognitoFormsScreen;

Logger.log('silly', `CognitoFormsScreen loaded.`);
